import { ListProvider } from "./list-provider";
import { User } from "../../../../business-objects/user/user.model";
import { UserStoreFacade } from "../../../../business-objects/user/user.store-facade";
import { ListPickerControlModalItemModel } from "../list-picker-control-modal-item.model";
import { Observable } from "rxjs/Observable";

export class UserListProvider extends ListProvider<User> {

    getFacade(): UserStoreFacade {
        return this.appFacade.objects.user.store;
    }

    getPrimaryField(item: User): string {
        return item && item.name || "NAME NOT SET";
    }

    getSecondaryField(item: User): string {
        return item && item.email;
    }

    getList(): Observable<Array<ListPickerControlModalItemModel>> {
        return this.getFacade()
            .getAll()
            .map(items => items.map(item => new ListPickerControlModalItemModel(item.id, this.getPrimaryField(item), this.getSecondaryField(item))));
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/user-list-provider.ts